export const Namespace = {
  Locale: 'locale',
  Login: 'login',
  Error: 'error',
  Appointment: 'appointment',
  Consultation: 'consultation',
  Terms: 'terms',
  Chipcard: 'chipcard',
} as const;
